import { render } from "./loginView.vue?vue&type=template&id=9c20bd8e&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=9c20bd8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c20bd8e"]])

export default __exports__